import { NgModule } from '@angular/core';
import { EquipmentEditPage } from 'pages/equipment/equipment-edit-page';
import { ComponentsModule } from 'components/components.module';
import { DirectivesModule } from 'directives/directives.module';
import { PagesModule } from 'pages/pages.module';

@NgModule({
    declarations: [EquipmentEditPage],
    imports: [PagesModule, ComponentsModule, DirectivesModule]
})
export class EquipmentEditPageModule { }
